import { useMutation } from '@tanstack/react-query';

import API from '@api/API';

import { useReferredBy } from '@hooks/useReferredBy';

interface AuthWithMagicLinkPayload {
  phoneNumber: string;
  sessionId?: string;
  referredBy?: string;
}
interface AuthWithMagicLinkResponseBody {
  userId: string;
}

export const useAuthWithMagicLink = () => {
  const { sessionId, referredBy } = useReferredBy();
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: AuthWithMagicLinkPayload) =>
      API.post<AuthWithMagicLinkResponseBody, AuthWithMagicLinkPayload>(
        '/v1/user/auth/magic-link',
        {
          ...payload,
          sessionId,
          referredBy,
        },
      ),
  });

  return {
    isSubmitting: isPending,
    authWithMagicLinkAsync: mutateAsync,
  };
};

interface ValidateAuthWithMagicLinkPayload {
  userId: string;
  code: string;
}
interface ValidateAuthWithMagicLinkResponseBody {
  user: any;
  token: string;
}

export const useValidateAuthWithMagicLink = () => {
  const { isPending, mutateAsync } = useMutation({
    mutationFn: (payload: ValidateAuthWithMagicLinkPayload) =>
      API.post<ValidateAuthWithMagicLinkResponseBody, ValidateAuthWithMagicLinkPayload>(
        '/v1/user/auth/magic-link/validate',
        payload,
      ),
  });

  return {
    isSubmitting: isPending,
    validateAuthWithMagicLinkAsync: mutateAsync,
  };
};
